export default class CalendarContextMenu {
  constructor() {
    this.$menu = $('#calendar-context-menu');
    if (!this.$menu.length) { return; }

    this.cancelUrl = this.$menu.data('cancel-url');
    this.pending = null;

    this.bindEvents();
  }

  bindEvents() {
    $(document).on('click.calendarCtxMenu', (e) => {
      if (!$(e.target).closest('#calendar-context-menu').length) {
        this.$menu.hide();
        this.pending = null;
      }
    });

    $('#calendar-ctx-cancel-reservation').on('click.calendarCtxMenu', () => {
      if (!this.pending) { return; }
      this.doCancel(this.pending);
      this.$menu.hide();
      this.pending = null;
    });
  }

  // Returns an eventDidMount callback to pass to FullCalendar.
  // onCancelSuccess(actionExecutionId, message) is called after successful cancel.
  getEventDidMount(onCancelSuccess) {
    return (info) => {
      if (info.event.extendedProps?.type !== 'reservation') { return; }

      info.el.addEventListener('contextmenu', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const props = info.event.extendedProps;
        this.show(e.clientX, e.clientY, props.reservation_id, props.action_execution_id, onCancelSuccess);
      });
    };
  }

  show(x, y, reservationId, actionExecutionId, onSuccess) {
    this.pending = { reservationId, actionExecutionId, onSuccess };
    this.$menu.css({ top: y, left: x }).show();
  }

  doCancel({ reservationId, actionExecutionId, onSuccess }) {
    const token = $('meta[name="csrf-token"]').attr('content');

    $.ajax({
      url: this.cancelUrl,
      method: 'DELETE',
      headers: { 'X-CSRF-Token': token, 'Accept': 'application/json' },
      contentType: 'application/json',
      data: JSON.stringify({ reservation_id: reservationId }),
      success: (data) => {
        if (data.success) {
          onSuccess(actionExecutionId, data.message);
          $.toast({
            heading: I18n.t('common.success'),
            text: data.message,
            icon: 'success',
            position: 'top-right',
            loader: true,
            loaderBg: '#28a745'
          });
        }
      },
      error: (xhr) => {
        const resp = xhr.responseJSON;
        $.toast({
          heading: I18n.t('common.error'),
          text: resp?.error || I18n.t('common.error'),
          icon: 'error',
          position: 'top-right',
          loader: true,
          loaderBg: '#dc3545'
        });
      }
    });
  }

  destroy() {
    $(document).off('click.calendarCtxMenu');
    $('#calendar-ctx-cancel-reservation').off('click.calendarCtxMenu');
    this.$menu.hide();
  }
}
